import { AxiosResponse } from 'axios';
import { api } from './config';

export interface RoutePoint {
  latitude: number;
  longitude: number;
  timestamp?: string;
}

export interface ActualRoute {
  distanceKm: number;
  routePointsCount: number;
  departureTime: string;
  arrivalTime?: string;
  durationMinutes: number;
  routePoints: RoutePoint[];
}

export interface OptimalRoute {
  distanceKm: number;
  durationMinutes: number;
  routePoints: RoutePoint[];
  averageSpeedLimitKmh?: number;
  maxSpeedLimitKmh?: number;
}

export interface CostComparison {
  actualFuelCost: number;
  actualTollFee: number;
  actualTotalCost: number;
  optimalFuelCost: number;
  optimalTollFee: number;
  optimalTotalCost: number;
  potentialFuelSavings: number;
  potentialTollSavings: number;
  potentialTotalSavings: number;
  savingsPercentage: number;
  distanceDifferenceKm: number;
  distanceDifferencePercentage: number;
}

export interface TollFeeLocation {
  tollFeeId: number;
  locationName: string;
  locationType: string; // "Province" or "District"
  fee: number;
  latitude?: number;
longitude?: number;
  address?: string;
  notes?: string;
  isPassed: boolean; // Whether the vehicle actually passed this location
}

export interface RouteAnalysis {
  shippingRecordId: number;
  shippingDate: string;
  licensePlate: string;
  vehicleId?: number;
  destination: string;
  provinceName?: string;
  districtName?: string;
homeLat: number;
  homeLon: number;
  destinationLat: number;
  destinationLon: number;
  actualRoute?: ActualRoute;
  optimalRoute?: OptimalRoute;
  costComparison?: CostComparison;
  fuelEfficiencyLitersPer100Km?: number;
  tollFeeLocations?: TollFeeLocation[];
}

export interface AlternativeRoute {
  destinationLat: number;
  destinationLon: number;
  homeLat: number;
  homeLon: number;
  optimalRoute: OptimalRoute;
  estimatedFuelCost: number;
  estimatedTollFee: number;
  estimatedTotalCost: number;
  fuelEfficiency?: number;
  fuelPricePerLiter?: number;
  tollFeeLocations?: TollFeeLocation[];
}

export const routeAnalysisApi = {
  /**
   * Analyze a single shipping record's route and costs
   */
  analyzeRoute: (shippingRecordId: number): Promise<AxiosResponse<RouteAnalysis>> =>
    api.get(`/routeanalysis/${shippingRecordId}`),

  /**
   * Analyze multiple shipping records at once
   */
  analyzeMultipleRoutes: (shippingRecordIds: number[]): Promise<AxiosResponse<RouteAnalysis[]>> =>
    api.post('/routeanalysis/analyze-multiple', shippingRecordIds),

  /**
   * Get alternative route and cost estimate for a destination
   */
  getAlternativeRoute: (
    destLat: number,
    destLon: number,
    vehicleId?: number
  ): Promise<AxiosResponse<AlternativeRoute>> =>
    api.get('/routeanalysis/alternative-route', {
      params: { destLat, destLon, vehicleId }
  })
};
